import React from 'react';
import { StyleSheet, Text, View } from 'react-native';
import { useTranslation } from 'react-i18next';
import { Paprika } from '../../styles/theme';

interface Props {
  /** Index of the question on screen, 1-based. */
  question: 1 | 2 | 3;
  /** How many answers are already in. */
  answered: number;
}

/** "Question n / 3", a thin terracotta bar and three squares that fill in. */
export function ProgressPile({ question, answered }: Props) {
  const { t } = useTranslation();
  return (
    <View style={styles.row} testID="onb-progress">
      <Text style={styles.count}>{t('onboarding.quiz.progress', { n: question })}</Text>
      <View style={styles.bar}><View style={[styles.fill, { width: `${(answered / 3) * 100}%` }]} /></View>
      <View style={styles.pile}>
        <Text style={styles.choose}>{t('onboarding.quiz.choose')}</Text>
        {[0, 1, 2].map((k) => (
          <View key={k} style={[styles.square, k < answered && styles.squareOn]} />
        ))}
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  row: { flexDirection: 'row', alignItems: 'center', gap: 12, paddingVertical: 8 },
  count: { fontFamily: 'Inter-SemiBold', fontSize: 11, letterSpacing: 1, textTransform: 'uppercase', color: Paprika.textSecondary },
  bar: { flex: 1, height: 3, borderRadius: 2, backgroundColor: Paprika.bgSunk, overflow: 'hidden' },
  fill: { height: 3, backgroundColor: Paprika.accent },
  pile: { flexDirection: 'row', alignItems: 'center', gap: 4 },
  choose: { fontFamily: 'Inter-Regular', fontSize: 11, color: Paprika.textMuted, marginRight: 4 },
  square: { width: 7, height: 9, borderRadius: 2, backgroundColor: Paprika.bgSunk },
  squareOn: { backgroundColor: Paprika.accent },
});
